'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('violation-ticket-list', {
      url: '/violation/ticket/list',
      template: '<violation-ticket-list></violation-ticket-list>',
      authenticate: true
    });
}



// WEBPACK FOOTER //
// ./client/app/violations/ticket-list/violations-ticket-list.routes.js